import React from 'react';

import { v4 as uuid } from 'uuid';
import './StepperNE.scss';

export interface StepperProps {
  labels: string[];
  active: number;
  orientation?: 'horizontal' | 'vertical';
  changeStep?: (stepIndex: number) => void;
}

const StepperNE = ({ labels, active, changeStep, orientation = 'horizontal' }: StepperProps) => {
  const verifyChangeStep = (index: number) => {
    if (index < active && changeStep) {
      changeStep(index);
    }
  };

  const lineClasses = (lineIndex: number) => {
    let className = 'stepper-line';
    if (orientation === 'vertical') {
      className = `${className} vertical`;
    }
    if (lineIndex < active) {
      className = `${className} active`;
    }
    return className;
  };

  return (
    <div className={orientation === 'vertical' ? 'stepper-container vertical' : 'stepper-container'}>
      {labels.map((item, index) => (
        <React.Fragment key={`stepper-${item}-${uuid()}`}>
          <div className="stepper-step">
            <div className={active < index ? 'stepper-number' : 'stepper-number active'}>{index + 1}</div>
            <div
              className={active < index ? 'stepper-text' : 'stepper-text active'}
              onClick={() => verifyChangeStep(index)}
            >
              {item}
            </div>
          </div>
          {index + 1 != labels.length && <div className={lineClasses(index)}></div>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default StepperNE;
